module.exports = __webpack_public_path__ + "static/media/gol-smiles-logo.c5c8f902.svg";